"use client";

import { SoftwarePC } from "./software-pc";
import { SoftwareMobile } from "./software-mobile";
import { useBreakpoint } from "@/shared/hooks/use-breakpoint";
import { SoftwareTablet } from "./software-tablet";

export function Software() {
  const { isPc, isTablet } = useBreakpoint();

  return (
    <main className="tb:py-[120px] software-container overflow-hidden scroll-smooth py-20">
      {isPc ? <SoftwarePC /> : isTablet ? <SoftwareTablet /> : <SoftwareMobile />}
    </main>
  );
}
